import { useQuery } from '@tanstack/react-query'

import { getDevSettings } from '@/requests/dev-settings/dev-settings.requests'

export interface UseDevSettingsOptions {
  /** Set false to skip the request — e.g. in production, where the endpoint always 403s. */
  enabled?: boolean
}

export function useDevSettings(options?: UseDevSettingsOptions) {
  const { enabled = true } = options ?? {}

  return useQuery({
    queryKey: ['dev-settings'],
    queryFn: getDevSettings,
    enabled,
  })
}
